export interface CircularBounds {
  x: number
  y: number
  radius: number
}

export function checkCircleCollision (circle1: CircularBounds, circle2: CircularBounds, minSeparation: number = 0): boolean {
  const dx = circle1.x - circle2.x
  const dy = circle1.y - circle2.y
  const distance = Math.sqrt(dx * dx + dy * dy)
  const minDistance = circle1.radius + circle2.radius + minSeparation

  return distance < minDistance
}

export function findValidPosition (
  centerX: number,
  centerY: number,
  nodeRadius: number,
  existingBounds: CircularBounds[],
  maxRadius: number,
  minSeparation: number = 10
): { x: number, y: number } | null {
  const radiusStep = nodeRadius * 2.2

  for (let radius = nodeRadius * 2; radius <= maxRadius; radius += radiusStep) {
    const circumference = 2 * Math.PI * radius
    const maxNodes = Math.floor(circumference / (nodeRadius * 2 + minSeparation))
    const angleStep = (2 * Math.PI) / maxNodes

    for (let i = 0; i < maxNodes; i++) {
      const angle = i * angleStep - Math.PI / 2
      const x = centerX + radius * Math.cos(angle)
      const y = centerY + radius * Math.sin(angle)

      const candidatePosition: CircularBounds = { x, y, radius: nodeRadius }

      const hasCollision = existingBounds.some(bounds =>
        checkCircleCollision(candidatePosition, bounds, minSeparation)
      )

      if (!hasCollision) {
        return { x, y }
      }
    }
  }

  return null
}
